import { DURATION_UNITS } from '../constants/common/duration-units';
import type { DurationPipeOptions } from '../interfaces/common/duration-options';
import type { Duration } from 'luxon';

export class DurationHelper {
  public static format(
    duration: Duration,
    options?: DurationPipeOptions,
  ): string {
    const {
      format = 'units',
      units = ['d', 'h', 'm'],
      singleUnit = false,
      past = false,
      negativeSign = false,
      plusSign = true,
      padHour = false,
    } = options ?? {};

    const isNegative = duration.toMillis() < 0;
    if (isNegative && !past) return '-';
    if (isNegative) duration = duration.negate();

    const { days, hasDays, hours, hasHours, minutes, seconds } = {
      days: Math.floor(duration.as('days')),
      hasDays: Math.floor(duration.as('days')) > 0,
      hours: Math.floor(duration.as('hours')),
      hasHours: Math.floor(duration.as('hours')) > 0,
      minutes: Math.floor(duration.as('minutes')),
      seconds: Math.ceil(duration.as('seconds')),
    };
    const [daysLabel, hoursLabel, minutesLabel, secondsLabel] = DURATION_UNITS;

    const result: string = (() => {
      if (format === 'clock') {
        return `${padHour ? hours.toString().padStart(2, '0') : hours}:${(minutes % 60).toString().padStart(2, '0')}`;
      }

      if (hasDays && units.includes('d')) {
        const convertedHours = hours % 24;
        return singleUnit
          ? `${days}${daysLabel}`
          : `${days}${daysLabel}${convertedHours > 0 ? ` ${convertedHours}${hoursLabel}` : ''}`;
      }

      if (hasHours && units.includes('h')) {
        const convertedMinutes = minutes % 60;
        return singleUnit
          ? `${hours}${hoursLabel}`
          : `${hours}${hoursLabel}${convertedMinutes > 0 ? ` ${convertedMinutes}${minutesLabel}` : ''}`;
      }

      return `${minutes}${units.includes('s') ? `${minutesLabel} ${seconds % 60}${secondsLabel}` : ' min'}`;
    })();

    return past && isNegative
      ? `${plusSign ? '+' : ''}${result}`
      : `${negativeSign ? '-' : ''}${result}`;
  }
}
